import { Slide } from "@jelly/lesson";

import testBench from "./components/test-bench";

const principle: Slide = {
  title: "Test Bench",
  layout: {
    type: "simple",
    options: {
      components: [testBench],
    },
  },
};

export default principle;
